// extracted by mini-css-extract-plugin
module.exports = {"content":"FloatingCta_content__nl4bW","byline":"FloatingCta_byline____M39","noCopy":"FloatingCta_noCopy___zizA","ctaBlock":"FloatingCta_ctaBlock__Nh1si"};